import { render, staticRenderFns } from "./EmiratesFilter.vue?vue&type=template&id=045b33ba&scoped=true"
import script from "./EmiratesFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmiratesFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmiratesFilter.vue?vue&type=style&index=0&id=045b33ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b33ba",
  null
  
)

export default component.exports